import { ButtonInterface } from "interfaces/interfaces-ui";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import arrowLeft from "assets/svg/arrowLeftPlain.svg";
import { motion } from "framer-motion";
import { ReactNode } from "react";

export const CButton = ({
  loading,
  text,
  icon,
  iconPosition = "right",
  variant = "plain",
  action,
  fullWidth,
  isSubmit,
  longer,
  textSmaller = false,
  shorter = false,
  rightIcon,
  smallWithCenterIconForMobile = false,
  disabled = false,
  noBorderRadius,
  pulsate,
  fullRounded,
  wider,
  smallerWidth,
  className,
}: ButtonInterface) => {
  //Note: Right icon only shows when the config for the component takes two icons, both right and left

  // Helper function to render icon (supports both string paths and React components)
  const renderIcon = (iconProp: string | ReactNode | undefined) => {
    if (!iconProp) return null;

    // If it's a string, render as img tag (legacy behavior)
    if (typeof iconProp === "string") {
      return <img alt="" src={iconProp} />;
    }

    // Otherwise, render as React component
    return <>{iconProp}</>;
  };

  return (
    <motion.button
      {...(pulsate && {
        animate: {
          scale: [1, 1.05, 1],
        },
        transition: {
          duration: 1,
          repeat: Infinity,
          ease: "easeInOut",
        },
      })}
      whileHover={
        !loading && !disabled ? { scale: 1.02, opacity: 0.9 } : undefined
      }
      whileTap={!loading && !disabled ? { scale: 0.98 } : undefined}
      disabled={loading || disabled}
      onClick={action}
      type={isSubmit ? "submit" : "button"}
      className={`${
        variant === "plain" || disabled
          ? "border border-[#AFAFAF]  bg-transparent text-[#545454]"
          : variant === "grey"
            ? "bg-[#F5F5F5] border border-[#EEEEEE]"
            : variant === "dark"
              ? "bg-[#000000] text-white"
              : variant === "orangePlain"
                ? "border border-[#FF6929] text-[#FF6929]"
                : variant === "orangeBg"
                  ? "border bg-[#FF6929] text-white"
                  : variant === "transparentPlain"
                    ? "bg-transparent border border-white text-white"
                    : variant === "primaryGrey"
                      ? "bg-[#AFAFAF] border border-[#CBCBCB] text-[#333333]"
                      : variant === "red"
                        ? "bg-[#D44333] text-white"
                        : variant === "orange-no-border"
                          ? "text-[#FF6929]"
                          : variant === "transparentWithGrayBorder"
                            ? "border border-[#ACB2BD] text-[#333333]"
                            : variant === "orange-light"
                              ? "bg-[#FFD1BD] text-[#FF6929]"
                              : variant === "bgGreyLight"
                                ? "bg-[#E2E2E2] border border-[#EFEFEF] text-[#545454]"
                                : variant === "white-bg"
                                  ? "bg-white text-[#545454] border border-[#EFEFEF]"
                                  : variant === "off-white"
                                    ? "bg-[#EEEEEE] text-[#333333]"
                                    : ""
      } ${wider ? "px-8" : smallerWidth ? "px-1" : "px-4"}   ${
        longer ? "py-3" : shorter ? "py-1" : "py-2"
      }  ${fullWidth && "w-full "}  ${
        !noBorderRadius && (fullRounded ? "rounded-full" : "rounded-lg")
      } font-grotesk font-semibold ${
        textSmaller ? "text-xs" : "lg:text-sm"
      }  text-xs flex justify-center items-center gap-2 ${
        loading && "opacity-25"
      } ${(disabled || loading) && "cursor-not-allowed"} transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF6929] ${className ?? ""}`}
    >
      {loading ? (
        <ClipLoader
          size={20}
          color={
            disabled
              ? "#000000"
              : variant === "dark"
                ? "#fff"
                : variant === "grey" || variant === "plain"
                  ? "#ED6E33"
                  : "white"
          }
        />
      ) : (
        <>
          {icon && (iconPosition === "left" || iconPosition === "both") && (
            <span className="flex items-center justify-center [ &_svg]:stroke-current">
              {renderIcon(icon)}
            </span>
          )}
          {text}
          {icon && (iconPosition === "right" || iconPosition === "both") && (
            <span className="flex items-center justify-center [ &_svg]:stroke-current">
              {renderIcon(iconPosition === "both" ? rightIcon : icon)}
            </span>
          )}
        </>
      )}
    </motion.button>
  );
};

export const BackButton = () => {
  const navigate = useNavigate();
  return (
    <>
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-1 py-2 px-4 border rounded-xl  "
      >
        <span>
          <img alt={""} src={arrowLeft} />
        </span>
        <p className="text-xs text-[#0E0E0E] font-semibold">Go back</p>
      </button>
    </>
  );
};
